import { render, staticRenderFns } from "./alertModal.vue?vue&type=template&id=0aa16566&scoped=true&name=alertModal&"
import script from "./alertModal.vue?vue&type=script&lang=js&"
export * from "./alertModal.vue?vue&type=script&lang=js&"
import style0 from "./alertModal.vue?vue&type=style&index=0&id=0aa16566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa16566",
  null
  
)

export default component.exports